import {
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { CDIChart } from '~/pages/Portal/StrategicMap/CDIChart';
import { useFeatureFlags } from '~/contexts/FeatureFlagsContext/FeatureFlagsContext';
import { MachineParkContractDetailView } from '~/types/strategicMap';
import { ContractView } from '~/types';
import { formataMesStrAno } from '~/utils/formatDate';
import { AdjustmentIndexChart } from '~/pages/Portal/StrategicMap/AdjustmentIndexChart';
import { AccumulatedPaymentChart } from '~/pages/Portal/StrategicMap/AccumulatedPaymentChart';
import { DolarChart } from '~/pages/Portal/StrategicMap/DolarChart';

export const ContractCharts: React.VFC<{
  contrato: MachineParkContractDetailView | ContractView;
  data_key: string;
  width?: string;
}> = ({ contrato, data_key, width = '72%' }) => {
  const featureflags = useFeatureFlags();

  const [key2, setKey2] = useState(0);
  const handleTabChange = () => {
    setKey2(prevKey => prevKey + 1); // Atualiza a chave para forçar a re-renderização
  };
  const estiloTabs = (label: string) => {
    return (
      <Tab
        style={{
          fontWeight: 'bold',
          fontSize: '15px',
          color: '#2E2E2E',
          backgroundColor: '#e1e1e1',
          borderRadius: '8px',
        }}
        _selected={{
          color: '#fdfdfe !important',
          backgroundColor: '#a67bc9 !important',
        }}
      >
        {label}
      </Tab>
    );
  };

  const dataInicialContrato = () => {
    return formataMesStrAno(contrato.dt_inicialcontrato);
  };
  const extensoesContrato = () => {
    if (contrato) {
      const extensoes = contrato.extensoes.map(
        extensao => extensao.dt_inicialinstrumento,
      );
      return extensoes.map(it => formataMesStrAno(it));
    }
    return [];
  };

  const indiceReajuste = () => {
    return contrato
      ? (contrato.nm_indicecorrecao.toUpperCase() as
          | 'IPCA'
          | 'IGPM'
          | 'INPC'
          | 'IPC')
      : undefined;
  };

  return (
    <Stack width={width}>
      <Tabs variant="soft-rounded" width="100%" onChange={handleTabChange}>
        <TabList style={{ border: 0 }} gridGap={3}>
          {featureflags.mapaEstrategicoContratosGraficoCDIEnabled &&
            estiloTabs('Gráfico CDI')}
          {indiceReajuste() &&
            featureflags.mapaEstrategicoContratosGraficoIndiceEnabled &&
            estiloTabs(`Gráfico ${indiceReajuste()}`)}
          {featureflags.mapaEstrategicoContratosGraficoDolarEnabled &&
            estiloTabs('Dólar')}
          {featureflags.mapaEstrategicoContratosGraficoPagAcumuladoEnabled &&
            estiloTabs('Pagamento acumulado')}
        </TabList>
        <TabPanels width="100%" overflowX="auto">
          {featureflags.mapaEstrategicoContratosGraficoCDIEnabled && (
            <TabPanel padding={0}>
              <CDIChart
                id_contrato={Number(contrato.id_contrato)}
                data_inicio={dataInicialContrato()}
                data_extensoes={extensoesContrato()}
                cdi_key={`${data_key}${key2}_cdi`}
              />
            </TabPanel>
          )}
          {indiceReajuste() &&
            featureflags.mapaEstrategicoContratosGraficoIndiceEnabled && (
              <TabPanel padding={0}>
                <AdjustmentIndexChart
                  id_contrato={Number(contrato.id_contrato)}
                  data_inicio={dataInicialContrato()}
                  data_extensoes={extensoesContrato()}
                  type={indiceReajuste() ?? 'IPCA'}
                  adjustment_key={`${data_key}${key2}_adjustment`}
                />
              </TabPanel>
            )}
          {featureflags.mapaEstrategicoContratosGraficoDolarEnabled && (
            <TabPanel padding={0}>
              <DolarChart
                id_contrato={Number(contrato.id_contrato)}
                data_inicio={dataInicialContrato()}
                dolar_key={`${data_key}${key2}_dolar`}
              />
            </TabPanel>
          )}
          {featureflags.mapaEstrategicoContratosGraficoPagAcumuladoEnabled && (
            <TabPanel padding={0}>
              <AccumulatedPaymentChart
                id_contrato={Number(contrato.id_contrato)}
                data_inicio={dataInicialContrato()}
                data_extensoes={extensoesContrato()}
                accumulated_key={`${data_key}${key2}_accumulated`}
              />
            </TabPanel>
          )}
        </TabPanels>
      </Tabs>
    </Stack>
  );
};
